/* eslint-disable @typescript-eslint/no-explicit-any */
import DateRangePicker from "components/DateRangePicker";
import {
  PickerRange,
  toIsoPeriod,
  toPickerRange,
} from "@/utils/date-range";
import { useStoreEmailFilterActions } from "../../filter/hooks/actions";
import { useFilterState } from "../../filter/hooks/filterState";
import { CONCILIATION_DATE_RANGE_FILTER_KEY } from "../../utils/constants";

export function DateRangeHeader() {
  const { updateFilter } = useStoreEmailFilterActions();
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };

  const getStoredFilters = () => JSON.parse(localStorage.getItem("manage-loss-filters") || "{}");
  const setStoredFilters = (filters: any) => localStorage.setItem("manage-loss-filters", JSON.stringify(filters));

  const handleDateRangeChange = (range: PickerRange | undefined) => {
    const value = range ? toIsoPeriod(range) : undefined;

    updateFilter({ key: CONCILIATION_DATE_RANGE_FILTER_KEY, value });
    updateFilter({ key: "meta", value: { page: 1, perPage: filters?.meta?.perPage || 10 } });

    const currentFilters = getStoredFilters();
    setStoredFilters({ ...currentFilters, [CONCILIATION_DATE_RANGE_FILTER_KEY]: value });
  };

  const dateRange = filters.conciliation_date_range;
  const currentDateRange: PickerRange | undefined = dateRange?.start &&
    dateRange?.end
    ? toPickerRange({ start: dateRange.start, end: dateRange.end })
    : undefined;

  return (
    <DateRangePicker
      key={[dateRange?.start, dateRange?.end].join()}
      date={currentDateRange}
      onDateChange={handleDateRangeChange}
      allowUnlimited={true}
      buttonClassName="!w-auto !bg-white !text-gray-700 !rounded-lg !shadow-sm hover:!bg-gray-50 !h-9 !px-3 !text-sm [border:1px_solid_rgb(209,213,219)] hover:[border-color:rgb(156,163,175)]"
      placeholder="Selecione um período"
    />
  );
}
